module.exports = __webpack_public_path__ + "img/apple-Imac.c243ba18.jpg";